import type {
  IClaimInvoice,
  IClaimInvoiceFilters,
  ICreateClaimInvoiceForm,
  IUpdateInvoiceForm,
} from '@/types/asicw/invoices'
import type { IPage } from '@/types/shared/pagination'
import axios from 'axios'

export async function getClaimInvoices(filters: IClaimInvoiceFilters): Promise<IPage<IClaimInvoice>> {
  const res = await axios.get(import.meta.env.VITE_APP_ASICW_CLAIM_INVOICES_ENDPOINT, { params: filters })
  return res.data
}

export async function createClaimInvoices(data: ICreateClaimInvoiceForm) {
  const res = await axios.post(`${import.meta.env.VITE_APP_ASICW_CLAIM_INVOICES_ENDPOINT}`, data)
  return res.data
}

export async function deleteClaimInvoice(invoiceId: number) {
  const res = await axios.delete(`${import.meta.env.VITE_APP_ASICW_CLAIM_INVOICES_ENDPOINT}/${invoiceId}`)
  return res.data
}

export async function refreshClaimInvoice(invoiceId: number) {
  const res = await axios.patch(`${import.meta.env.VITE_APP_ASICW_CLAIM_INVOICES_ENDPOINT}/${invoiceId}/refresh`)
  return res.data
}

export async function updateClaimInvoice(invoiceId: number, data: IUpdateInvoiceForm) {
  const res = await axios.patch(`${import.meta.env.VITE_APP_ASICW_CLAIM_INVOICES_ENDPOINT}/${invoiceId}`, data)
  return res.data
}

export async function exportClaimInvoiceCSV(invoiceId: number): Promise<Blob> {
  const res = await axios.get(`${import.meta.env.VITE_APP_ASICW_CLAIM_INVOICES_ENDPOINT}/${invoiceId}/export`, {
    responseType: 'blob',
  })
  return res.data
}
